import { createFileRoute } from "@tanstack/react-router"
import { CreateCustomCapability } from "modules/capabilities/components/CreateCustomCapability"
import { z } from "zod"

const SearchSchema = z.object({
  kind: z.enum(["webhook", "instruction", "mcp"]),
})

export const Route = createFileRoute("/_base/_auth/capabilities/list/create-custom")({
  component: RouteComponent,
  validateSearch: SearchSchema,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const search = Route.useSearch()

  function onClose() {
    navigate({ to: "/capabilities/list", search })
  }

  return <CreateCustomCapability onOpenChange={onClose} kind={search.kind} />
}
